import type {Auth, Document, ViewableExemplar, Volume} from 'typings/portaro.be.types';
import type ExemplarService from '../exemplar.service';
import type {VolumeDataService} from './volume.data-service';
import type ExemplarDataService from '../exemplar.data-service';
import type VolumeService from './volume.service';
import type {IssueAwareVolume, KpVolumesInitializeData} from './types';
import {byProperty, anyMatches} from 'shared/utils/array-utils';
import ExemplarFilter from '../exemplar-filter';

export class KpVolumesPresenter {
    public static presenterName = 'kpVolumesPresenter';

    /*@ngInject*/
    constructor(
        private exemplarService: ExemplarService,
        private exemplarDataService: ExemplarDataService,
        private volumeDataService: VolumeDataService,
        private volumeService: VolumeService,
        private currentAuth: Auth) {
    }

    public async initializeComponentData(document: Document, exemplarStatuses: number[]): Promise<KpVolumesInitializeData> {
        const exemplarFilter = new ExemplarFilter(exemplarStatuses);
        const volumes = await this.volumeDataService.query({document: document.id});

        return {
            exemplarFilter,
            volumes: volumes.map((v) => {
                return {...v, issues: null} as IssueAwareVolume;
            })
        }
    }

    public async loadIssues(volume: IssueAwareVolume, exemplarFilter: ExemplarFilter): Promise<ViewableExemplar[]> {
        const issues = await this.exemplarDataService.query({
            volume: volume.id,
            viewable: true,
            user: this.currentAuth.activeUser.id
        });

        return issues.filter(exemplarFilter.forUser(this.currentAuth));
    }

    public haveVolumesAnyIssue(volumes: Volume[]): boolean {
        return anyMatches(volumes, byProperty('withIssues', true));
    }

    public async createIssue(document: Document, volume: Volume): Promise<void> {
        await this.exemplarService.createIssue(document, volume);
    }

    public async showVolumeCreation(document: Document): Promise<void> {
        await this.volumeService.createVolume(document);
    }

    public async showVolumeEditation(volume: Volume, document: Document): Promise<void> {
        await this.volumeService.editVolume(volume, document);
    }

    public async deleteVolume(volume: Volume): Promise<void> {
        await this.volumeService.deleteVolume(volume);
    }
}